'use strict';

import { getCurrentLangDirection } from '../../components/langSwitcher/langSwitcher';
import gsap from "gsap";
import { isMobile, threeJsVariables, UIRoot } from '../../../settings';
import {isDesktop} from "../../../settings";
import {BaseElement} from "../../interfaces/BaseElement";

export function bottomNavBarInit () {
  const mainContainer = new BaseElement()
    .addClass('bottom__nav-bar')
    .appendTo(isDesktop ? document.querySelector('.aside__container') : UIRoot);
  
  if (threeJsVariables.orbitBuildingsNavigation.active && isMobile) {
    mainContainer.addClass('--orbit-buildings-navigation-exist');
  }

  animateBottomNavBar(mainContainer.DOMElement);

  return mainContainer.DOMElement;
}

export function animateBottomNavBar (container) {
  const langDirection = getCurrentLangDirection();
  let side = langDirection === 'ltr' ? 'right' : 'left';

  switch (isDesktop) {
    case 'rtl':
      side = 'left';
      break;
    case 'ltr':
      break;
  }

  gsap.fromTo(container,{[side]: -200, opacity:0 },{[side]:32, duration: 1, opacity: 1,onComplete:()=>{
    resetBottomNavBarAnimation(container);
    }});
}

function resetBottomNavBarAnimation (container) {
  container.style.removeProperty('left');
  container.style.removeProperty('right');
}
